<template>
    <ul class="menu--nqt">
        <h2 style="margin-bottom: 10px;">{{$t('manage_lesson.lesson_list')}}</h2>        
        <!-- Danh sách -->
        <li class="div-week-nd" v-for="(item1, index1) in menu" :key="index1">
            <template v-if="index1 == 0">
                <div class="noteDot">
                    <span class="dot dot--undone"></span>
                    <span>{{$t('week.undone')}}</span>
                    <span class="dot dot--studing"></span>
                    <span>{{$t('week.studing')}}</span>
                    <span class="dot dot--done"></span>
                    <span>{{$t('week.done')}}</span>
                </div>
                <ul class="tb-week font-blod">
                    <li>{{$t('week.status')}}</li>
                    <li>{{$t('week.exercise')}}</li>
                    <li>{{$t('week.score')}}</li>
                </ul>
            </template>
            <template>
                <template v-if="item1.thirdOutlineList == null">
                    <ul class="nested parent-ul active">
                        <li :class="[{noTitle:item1.thirdOutlineList == null}, {exerciseDoneDraft:item1.learningState == $CONST.MENU.LEARNING_COMPLETED && item1.thirdOutlineList == null}]">
                            <span :class="[{caret:item1.thirdOutlineList != null}]" class="lkt-title" @click="item1.thirdOutlineList == null ? null : toggleClass($event, item1.id)">
                                {{item1.chapterName}}
                            </span>
                            <ul v-if="item1.thirdOutlineList == null" class="tb-week" :class="[{infoParent:item1.thirdOutlineList == null}]">
                                <!-- status -->
                                <template v-if="item1.thirdOutlineList == null">
                                    <template v-if="item1.learningState == $CONST.MENU.LEARNING_COMPLETED">
                                        <li><img class="img-bh" src="../../../../static/images/baihoc-xanhla.png" /></li>
                                    </template>
                                    <template v-else-if="item1.learningState == $CONST.MENU.LEARNING">
                                        <li><img class="img-bh" src="../../../../static/images/baihoc-do.png" /></li>
                                    </template>
                                    <template v-else>
                                        <li><img class="img-bh" src="../../../../static/images/baihoc-den.png" /></li>
                                    </template>
                                </template>
                                <!-- isExercise -->
                                <template>
                                    <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                                        <template v-if="item1.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item1.score) < parseInt(item1.passingRateQuiz))">
                                            <li><img src="../../../../static/images/baitap-do.png" /></li>
                                        </template>
                                        <template v-else-if="item1.exerciseType == $CONST.MENU.EXERCISE_FINISHED">
                                            <li><img src="../../../../static/images/baitap-xanhla.png" /></li>
                                        </template>
                                        <template v-else>
                                            <li><img src="../../../../static/images/baitap-den.png" /></li>
                                        </template>
                                    </template>
                                    <template v-else><li>—</li></template>
                                </template>
                                <!-- score -->
                                <template>
                                    <template v-if="item1.score != '—'">
                                        <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                                            <li class="nqt-score" :class="[{done_score: item1.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, {}, {}, {}, {}, item1)">
                                                <a class="btn-number">{{item1.score}}%</a>
                                            </li>
                                        </template>
                                        <template v-else><li>—</li></template>
                                    </template>
                                    <template v-else><li>{{item1.score}}</li></template>
                                </template>
                            </ul>
                        </li>
                    </ul>
                </template>
                <template v-else>
                    <span
                        :class="[{caret:item1.thirdOutlineList != null}, {'caret-down': activeMenu == item1.id || activeMenu == null}]"
                        class="parent-ul-ol caret-float"
                        @click="item1.thirdOutlineList == null ? null : toggleClass($event, item1.id)"
                    >
                        {{item1.chapterName}}
                    </span>
                    <ul v-if="item1.thirdOutlineList == null" class="tb-week" :class="[{infoParent:item1.thirdOutlineList == null}]">
                        <!-- status -->
                        <template v-if="item1.thirdOutlineList == null">
                            <template v-if="item1.learningState == $CONST.MENU.LEARNING_COMPLETED">
                                <li><img class="img-bh" src="../../../../static/images/baihoc-xanhla.png" /></li>
                            </template>
                            <template v-else-if="item1.learningState == $CONST.MENU.LEARNING">
                                <li><img class="img-bh" src="../../../../static/images/baihoc-do.png" /></li>
                            </template>
                            <template v-else>
                                <li><img class="img-bh" src="../../../../static/images/baihoc-den.png" /></li>
                            </template>
                        </template>
                        <!-- isExercise -->
                        <template>
                            <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                                <template v-if="item1.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item1.score) < parseInt(item1.passingRateQuiz))">
                                    <li><img src="../../../../static/images/baitap-do.png" /></li>
                                </template>
                                <template v-else-if="item1.exerciseType == $CONST.MENU.EXERCISE_FINISHED">
                                    <li><img src="../../../../static/images/baitap-xanhla.png" /></li>
                                </template>
                                <template v-else>
                                    <li><img src="../../../../static/images/baitap-den.png" /></li>
                                </template>
                            </template>
                            <template v-else><li>—</li></template>
                        </template>
                        <!-- score -->
                        <template>
                            <template v-if="item1.score != '—'">
                                <template v-if="item1.isExercise != $CONST.MENU.EXERCISE_NONE">
                                    <li class="nqt-score" :class="[{done_score: item1.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, {}, {}, {}, {}, item1)">
                                        <a class="btn-number">{{item1.score}}%</a>
                                    </li>
                                </template>
                                <template v-else><li>—</li></template>
                            </template>
                            <template v-else><li>{{item1.score}}</li></template>
                        </template>
                    </ul>
                </template>
            </template>
            <ul v-if="item1.thirdOutlineList != null && item1.thirdOutlineList.length > 0" :class="[{nested:item1.thirdOutlineList != null}]">
                <li
                    v-for="(item2, index2) in item1.thirdOutlineList"
                    :class="[{noTitle:item2.thirdOutlineList == null}, {exerciseDoneDraft:item2.learningState == $CONST.MENU.LEARNING_COMPLETED && item2.thirdOutlineList == null}]"
                    :key="index2"
                >
                    <span :class="[{caret:item2.thirdOutlineList != null}]" class="caret-down color-2" @click="item2.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item2.chapterName}}</span>
                    <ul v-if="item2.thirdOutlineList == null" class="tb-week">
                        <!-- status -->
                        <template v-if="item2.thirdOutlineList == null">
                            <template v-if="item2.learningState == $CONST.MENU.LEARNING_COMPLETED">
                                <li><img class="img-bh" src="../../../../static/images/baihoc-xanhla.png" /></li>
                            </template>
                            <template v-else-if="item2.learningState == $CONST.MENU.LEARNING">
                                <li><img class="img-bh" src="../../../../static/images/baihoc-do.png" /></li>
                            </template>
                            <template v-else>
                                <li><img class="img-bh" src="../../../../static/images/baihoc-den.png" /></li>
                            </template>
                        </template>
                        <!-- isExercise -->
                        <template>
                            <template v-if="item2.isExercise != $CONST.MENU.EXERCISE_NONE">
                                <template v-if="item2.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item2.score) < parseInt(item2.passingRateQuiz))">
                                    <li><img src="../../../../static/images/baitap-do.png" /></li>
                                </template>
                                <template v-else-if="item2.exerciseType == $CONST.MENU.EXERCISE_FINISHED">
                                    <li><img src="../../../../static/images/baitap-xanhla.png" /></li>
                                </template>
                                <template v-else>
                                    <li><img src="../../../../static/images/baitap-den.png" /></li>
                                </template>
                            </template>
                            <template v-else><li>—</li></template>
                        </template>
                        <!-- score -->
                        <template>
                            <template v-if="item2.score != '—'">
                                <template v-if="item2.isExercise != $CONST.MENU.EXERCISE_NONE">
                                    <li class="nqt-score" :class="[{done_score: item2.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, {}, {}, {}, item2)">
                                        <a class="btn-number">{{item2.score}}%</a>
                                    </li>
                                </template>
                                <template v-else><li>—</li></template>
                            </template>
                            <template v-else><li>{{item2.score}}</li></template>
                        </template>
                    </ul>
                    <ul v-if="item2.thirdOutlineList != null && item2.thirdOutlineList.length > 0" :class="[{nested:item2.thirdOutlineList != null}]" class="active">
                        <li
                            v-for="(item3, index3) in item2.thirdOutlineList"
                            :class="[{noTitle:item3.thirdOutlineList == null}, {exerciseDoneDraft:item3.learningState == $CONST.MENU.LEARNING_COMPLETED && item3.thirdOutlineList == null}]"
                            :key="index3"
                        >
                            <span :class="[{caret:item3.thirdOutlineList != null}]" class="caret-down color-3" @click="item3.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item3.chapterName}}</span>
                            <ul v-if="item3.thirdOutlineList == null" class="tb-week">
                                <!-- status -->
                                <template v-if="item3.thirdOutlineList == null">
                                    <template v-if="item3.learningState == $CONST.MENU.LEARNING_COMPLETED">
                                        <li><img class="img-bh" src="../../../../static/images/baihoc-xanhla.png" /></li>
                                    </template>
                                    <template v-else-if="item3.learningState == $CONST.MENU.LEARNING">
                                        <li><img class="img-bh" src="../../../../static/images/baihoc-do.png" /></li>
                                    </template>
                                    <template v-else>
                                        <li><img class="img-bh" src="../../../../static/images/baihoc-den.png" /></li>
                                    </template>
                                </template>
                                <!-- isExercise -->
                                <template>
                                    <template v-if="item3.isExercise != $CONST.MENU.EXERCISE_NONE">
                                        <template v-if="item3.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item3.score) < parseInt(item3.passingRateQuiz))">
                                            <li><img src="../../../../static/images/baitap-do.png" /></li>
                                        </template>
                                        <template v-else-if="item3.exerciseType == $CONST.MENU.EXERCISE_FINISHED">
                                            <li><img src="../../../../static/images/baitap-xanhla.png" /></li>
                                        </template>
                                        <template v-else>
                                            <li><img src="../../../../static/images/baitap-den.png" /></li>
                                        </template>
                                    </template>
                                    <template v-else><li>—</li></template>
                                </template>
                                <!-- score -->
                                <template>
                                    <template v-if="item3.score != '—'">
                                        <template v-if="item3.isExercise != $CONST.MENU.EXERCISE_NONE">
                                            <li class="nqt-score" :class="[{done_score: item3.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, item3, {}, {}, item3)">
                                                <a class="btn-number">{{item3.score}}%</a>
                                            </li>
                                        </template>
                                        <template v-else><li>—</li></template>
                                    </template>
                                    <template v-else><li>{{item3.score}}</li></template>
                                </template>
                            </ul>
                            <ul v-if="item3.thirdOutlineList != null && item3.thirdOutlineList.length > 0" :class="[{nested:item3.thirdOutlineList != null}]" class="active">
                                <li
                                    v-for="(item4, index4) in item3.thirdOutlineList"
                                    :class="[{noTitle:item4.thirdOutlineList == null}, {exerciseDoneDraft:item4.learningState == $CONST.MENU.LEARNING_COMPLETED && item4.thirdOutlineList == null}]"
                                    :key="index4"
                                >
                                    <span :class="[{caret:item4.thirdOutlineList != null}]" class="caret-down color-4" @click="item4.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item4.chapterName}}</span>
                                    <ul v-if="item4.thirdOutlineList == null" class="tb-week">
                                        <!-- status -->
                                        <template v-if="item4.thirdOutlineList == null">
                                            <template v-if="item4.learningState == $CONST.MENU.LEARNING_COMPLETED">
                                                <li><img class="img-bh" src="../../../../static/images/baihoc-xanhla.png" /></li>
                                            </template>
                                            <template v-else-if="item4.learningState == $CONST.MENU.LEARNING">
                                                <li><img class="img-bh" src="../../../../static/images/baihoc-do.png" /></li>
                                            </template>
                                            <template v-else>
                                                <li><img class="img-bh" src="../../../../static/images/baihoc-den.png" /></li>
                                            </template>
                                        </template>
                                        <!-- isExercise -->
                                        <template>
                                            <template v-if="item4.isExercise != $CONST.MENU.EXERCISE_NONE">
                                                <template v-if="item4.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item4.score) < parseInt(item4.passingRateQuiz))">
                                                    <li><img src="../../../../static/images/baitap-do.png" /></li>
                                                </template>
                                                <template v-else-if="item4.exerciseType == $CONST.MENU.EXERCISE_FINISHED">
                                                    <li><img src="../../../../static/images/baitap-xanhla.png" /></li>
                                                </template>
                                                <template v-else>
                                                    <li><img src="../../../../static/images/baitap-den.png" /></li>
                                                </template>
                                            </template>
                                            <template v-else><li>—</li></template>
                                        </template>
                                        <!-- score -->
                                        <template>
                                            <template v-if="item4.score != '—'">
                                                <template v-if="item4.isExercise != $CONST.MENU.EXERCISE_NONE">
                                                    <li class="nqt-score" :class="[{done_score: item4.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, item3, item4, {}, item4)">
                                                        <a class="btn-number">{{item4.score}}%</a>
                                                    </li>
                                                </template>
                                                <template v-else><li>—</li></template>
                                            </template>
                                            <template v-else><li>{{item4.score}}</li></template>
                                        </template>
                                    </ul>
                                    <ul v-if="item4.thirdOutlineList != null && item4.thirdOutlineList.length > 0" :class="[{nested:item4.thirdOutlineList != null}]" class="active">
                                        <li
                                            v-for="(item5, index5) in item4.thirdOutlineList"
                                            :class="[{noTitle:item5.thirdOutlineList == null}, {exerciseDoneDraft:item5.learningState == $CONST.MENU.LEARNING_COMPLETED && item5.thirdOutlineList == null}]"
                                            :key="index5"
                                        >
                                            <span :class="[{caret:item5.thirdOutlineList != null}]" class="color-5" @click="item5.thirdOutlineList == null ? null : toggleClass($event, item1.id)">{{item5.chapterName}}</span>
                                            <ul v-if="item5.thirdOutlineList == null" class="tb-week">
                                                <!-- status -->
                                                <template v-if="item5.thirdOutlineList == null">
                                                    <template v-if="item5.learningState == $CONST.MENU.LEARNING_COMPLETED">
                                                        <li><img class="img-bh" src="../../../../static/images/baihoc-xanhla.png" /></li>
                                                    </template>
                                                    <template v-else-if="item5.learningState == $CONST.MENU.LEARNING">
                                                        <li><img class="img-bh" src="../../../../static/images/baihoc-do.png" /></li>
                                                    </template>
                                                    <template v-else>
                                                        <li><img class="img-bh" src="../../../../static/images/baihoc-den.png" /></li>
                                                    </template>
                                                </template>
                                                <!-- isExercise -->
                                                <template>
                                                    <template v-if="item5.isExercise != $CONST.MENU.EXERCISE_NONE">
                                                        <template v-if="item5.exerciseType == $CONST.MENU.EXERCISE_SENT || (parseInt(item5.score) < parseInt(item5.passingRateQuiz))">
                                                            <li><img src="../../../../static/images/baitap-do.png" /></li>
                                                        </template>
                                                        <template v-else-if="item5.exerciseType == $CONST.MENU.EXERCISE_FINISHED">
                                                            <li><img src="../../../../static/images/baitap-xanhla.png" /></li>
                                                        </template>
                                                        <template v-else>
                                                            <li><img src="../../../../static/images/baitap-den.png" /></li>
                                                        </template>
                                                    </template>
                                                    <template v-else><li>—</li></template>
                                                </template>
                                                <!-- score -->
                                                <template>
                                                    <template v-if="item5.score != '—'">
                                                        <template v-if="item5.isExercise != $CONST.MENU.EXERCISE_NONE">
                                                            <li class="nqt-score" :class="[{done_score: item5.score == $CONST.MENU.MAX_PERCENT}]" @click="jumpTaskResult(item1, item2, item3, item4, item5, item5)">
                                                                <a class="btn-number">{{item5.score}}%</a>
                                                            </li>
                                                        </template>
                                                        <template v-else><li>—</li></template>
                                                    </template>
                                                    <template v-else><li>{{item5.score}}</li></template>
                                                </template>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    export default {
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        data() {
            return {
                result: [],
                activeMenu: null
            };
        },
        created() {
            this.init({courseId: this.data.courseId, studentId: this.data.studentId});
        },
        computed: {
            // Convert data
            menu() {
                let data = this.result;
                data.forEach(async (item) => {
                    item["exerciseType"] = item.questionStatus;
                    let keyParent = data.findIndex((x) => x.id == item.parentId);
                    if (keyParent >= 0) {
                        data[keyParent].thirdOutlineList = data[keyParent].thirdOutlineList == null ? [] : data[keyParent].thirdOutlineList;
                        data[keyParent].thirdOutlineList.push(item);
                    }
                });

                return data.filter((x) => x.level == 1);
            },

            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile
            }),
        },
        methods: {
            init: async function (param) {
                // Lấy danh sách menu của học viên đối với khóa học
                this.result = await this.getCourseSubOutlineListByTopOutline(param);
            },

            // Ẩn / Hiện item
            toggleClass: function(event) {
                event.target.classList.toggle("caret-down");
                event.target.nextElementSibling.classList.toggle("active");
            },

            // Lấy danh sách menu
            getCourseSubOutlineListByTopOutline: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getCourseSubOutlineListByTopOutline", {
                        courseId: data.courseId,
                        userId: data.studentId,
                    })
                    .then(async (response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
                });
            },

            // Đến trang bài tập
            jumpTaskResult: function (item1, item2, item3, item4, item5, oop) {
                if (oop.thirdOutlineList != null) return;

                // Mở component wrongAnswer
                let dataWrongAnswer = {
                    courseName: this.courseName,
                    studentId: this.data.studentId,
                    courseOutlineId: oop.id,
                };

                // Lưu vào store
                this.setDataWrongAnswer(dataWrongAnswer);
                this.setShowWrongAnswer(true);
            },

            // vuex
            ...mapMutations("manageDetail", ["setDataWrongAnswer", "setShowWrongAnswer"])
        }
    };
</script>

<style scoped>
    .caret-float {
        text-transform: unset;
    }
    .lkt-title {
        font-size: 18px;
        font-weight: lighter;
    }
    .tb-week img {
        cursor: auto;
    }
    .nqtLearnPercent {
        margin-bottom: 15px;
    }
    .menu--nqt {
        margin-top: 20px;
    }
    .dot.dot--studing {
        background: #da251d;
    }
    @media (max-width: 480px) {
        .btn-number{margin-left: 2px} 
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/detail/menu.vue